import React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";

import { SportOffer, TournamentOffer } from "@gp/offer";
import { Category } from "@gp/models";

import { TournamentHeaderBettingTypeColumns } from "..";

import { TournamentHeaderName } from "./TournamentHeaderName";
import { TournamentHeaderCollapseIndicator } from "./TournamentHeaderCollapseIndicator";
import { OfferHistoryResultHeader } from "./OfferHistoryResultHeader";

export const TournamentHeader = observer(function TournamentHeader(props: {
	sport: SportOffer;
	category: Category;
	tournament: TournamentOffer;
	setHidden: (value: boolean) => void;
	hidden: boolean;
	isAdditionalOfferVisible?: boolean;
}) {
	return (
		<div
			className={classNames("offer__head offer--sports__head", {
				"is-collapsed": props.hidden,
				"is-expanded": !props.hidden,
			})}
		>
			<div className="offer__head__row">
				<TournamentHeaderName
					sport={props.sport}
					category={props.category}
					tournament={props.tournament}
					isAdditionalOfferVisible={props.isAdditionalOfferVisible}
				/>
				<OfferHistoryResultHeader />
				<TournamentHeaderBettingTypeColumns />
				<TournamentHeaderCollapseIndicator
					setHidden={props.setHidden}
					hidden={props.hidden}
					isAdditionalOfferVisible={props.isAdditionalOfferVisible}
				/>
			</div>
		</div>
	);
});
